export class PlatformSettingsConfig {
  public static EndPoint = {
    ConfigSettings: {
      getConfigList: '/org/config-settings/list',
      getConfigById: '/org/config-settings/list?id=',
      saveConfig: '/org/config-settings/create',
      updateConfig: '/org/config-settings/',
      datetimeFomrat: '/platform/master/lookup/lookupbycategoryname/DATETIME_FORMAT',
      timezone: '/platform/master/lookup/lookupbycategoryname/TIMEZONE',
      getConfigurationsByOrgId: '/org/config-settings/listbyOrgId/'
    }
  };
}
